export default "__VITE_ASSET__LznBtG5F__"